<template>
  <div>
    <h2 class="createTitle">创建应用</h2>

    <div class="createHtml-box">
      <div class="createHtml">
        <div class="createBody">
          <div class="steps-box">
            <el-steps :active="component - 1" align-center>
              <el-step
                title="选择功能板块"
                description="选择想要您想要创建的功能，选择多个可享打包价噢"
              ></el-step>
              <el-step
                title="选择套餐与功能"
                description="查看套餐内功能，选择所需终端或另外加购更多应用"
              ></el-step>
              <el-step
                title="确认订单"
                description="确认您选购的套餐和功能清单，并选择支付方式完成支付"
              ></el-step>
              <el-step
                title="创建应用"
                description="立即填写应用的名字吧！给你的软件起个响亮的名字，可稍后设置"
              ></el-step>
            </el-steps>
          </div>
        </div>
      </div>

      <component
        :is="isComponentName"
        ref="createAn"
        :loading8="loading8"
        :is-succeed="isSucceed"
        :plan-data="planData"
        :open-u-r-l="openURL"
        :pladList="pladList"
        :mergeArr="mergeArr"
        :calcParam="calcParam"
        :appData="appData"
        :calcData="calcData"
        :createAn4Param="createAn4Param"
        @onRredictNum="onRredictNum"
      ></component>

      <div
        class="createrAn-Buttom-box"
        :style="isComponentName === 'createAn2' ? '' : 'justify-content: center'"
      >
        <div class="right intro-x" v-if="isComponentName === 'createAn2'">
          <span class="span1">
            <div>
              <font style="font-size: 18px; color: #333333">预估合计：</font>
              <font style="font-size: 18px; color: #ff4242">{{ predictNum | formatMoney }}元</font>
            </div>
            <div>已选 <font style="color: #1890ff">{{labelNum}}</font> 个功能</div>
          </span>
        </div>

        <div v-if="isButtom1" class="createrAn-Buttom intro-x">
          <span class="span0 span1" @click="lastStep">{{
            component == 1 ? "取消" : "上一步"
          }}</span>
          <el-button
            :loading="payLoading"
            style="border: none; vertical-align: middle; line-height: 13px"
            class="span0 span2"
            @click="nextStep"
            >{{ isComponentName === "createAn5" ? "付款" : "下一步" }}</el-button
          >
        </div>
        <div
          v-if="isComponentName === 'zhifubao1' && ZHIFUBAO"
          class="createrAn-Buttom intro-x"
        >
          <div class="button" @click="getPayResults">我已完成支付，下一步</div>
        </div>
        <div v-if="isComponentName === 'createAn6'" class="createrAn-Buttom intro-x">
          <span v-if="!isSucceed" class="span9 span1" @click="lastStep2"
            >返回重新选择支付方式</span
          >
          <span v-if="calcData.pay_way === '0'" class="span9 span2" @click="nextStep2">
            {{ isSucceed ? "下一步" : "点击前往充值页面进行充值" }}</span
          >
          <span v-else class="span9 span2" @click="nextStep2">
            {{ isSucceed ? "下一步" : "重新查询" }}</span
          >
        </div>
        <div v-if="isButtom3" class="createrAn-Buttom intro-x">
          <span class="span9 span1" @click="nextStep3('稍后设置')">稍后设置</span>
          <span class="span9 span2" @click="nextStep3('下一步')">下一步</span>
        </div>
        <div v-if="isButtom4" class="createrAn-Buttom intro-x">
          <span
            class="span9 span2"
            :class="{ loading8Clss: loading8 }"
            @click="nextStep4"
            >{{
              userInfo.id_card === "" ? "去认证，开启赚钱之路" : "前往我的应用页面"
            }}</span
          >
        </div>
      </div>
    </div>

    <IDCard v-if="isIdCard" @setCancel="setCancel" />
  </div>
</template>

<script>
import createAn1 from "../modules/createAn1";
import createAn2 from "../modules/createAn2";

import createAn4 from "../modules/createAn4";
import createAn5 from "../modules/createAn5";
import createAn6 from "../modules/createAn6";
import createAn7 from "../modules/createAn7";
import createAn8 from "../modules/createAn8";
import zhifubao1 from "../modules/zhifubao1";
import shouxin1 from "../modules/shouxin1";

import IDCard from "../modules/IDVerification";
import Cookies from "js-cookie";

import request from "../utils/request";

export default {
  components: {
    createAn1,
    createAn2,
    createAn4,
    createAn5,
    createAn6,
    createAn7,
    createAn8,
    zhifubao1,
    shouxin1,
    IDCard,
  },
  data() {
    return {
      component: 1,
      predictNum: 0,
      labelNum:0,
      isComponentName: "createAn1",
      loading8: true,
      isSucceed: true,
      isButtom3: false,
      isButtom4: false,
      openURL: null,
      planData: [],
      pladList: null,
      ZHIFUBAO: false,
      appData: null,
      payLoading: false,
      isIdCard: false,
      mergeArr: null,
      calcParam: null,
      calcData: null,
      createAn4Param: null,
    };
  },
  computed: {
    userInfo: function () {
      return JSON.parse(Cookies.get("userInfo"));
    },

    isButtom1: function () {
      let arr = ["createAn1", "createAn2", "createAn4", "createAn5", "shouxin1"];
      let type = false;

      for (let i in arr) {
        if (this.isComponentName.indexOf(arr[i]) != -1) {
          type = true;
          break;
        } else {
          type = false;
        }
      }
      return type;
    },
    fSystem: function () {
      return function (value) {
        if (value === "android") return "安卓";
        if (value === "ios") return "苹果";
        if (value === "applet") return "小程序";
        if (value === "web") return "H5";
      };
    },
  },

  mounted() {
    // this.getPlan();
    // console.log(2)
  },

  activated() {
    this.isComponentName = "createAn1";
    this.component = 1;
    this.getPlan();
  },

  methods: {
    onRredictNum: function (data) {
      this.predictNum = data.predictNum
      this.labelNum = data.labelNum
    },

    setCancel: function (value, name) {
      if (value === "IDVerification") {
        this.isIdCard = false;
        if (name === "刷新") {
          this.userInfo.id_card = JSON.parse(Cookies.get("userInfo")).id_card;
          return;
        }
        if (name === "失败") {
          return;
        }
      }
    },

    async nextStep() {
      // 选择板块
      if (this.isComponentName === "createAn1") {
        if (
          this.$refs.createAn.planData.filter((item) => {
            return item.laber === true;
          }).length >= 1
        ) {
          this.isComponentName = "createAn2";
          this.component++;
        } else {
          this.$message.error("请选择功能板块");
        }

        return;
      }

      if (this.isComponentName === "createAn2") {
        let pladList = this.$refs.createAn.pladList;

        for (let i in pladList) {
          let platform = pladList[i].combo;
          let formName = await this.getPlatformName(platform);
          if (formName === "") {
            return this.$message.error("有套餐未选择内置功能模块！");
          }
        }

        this.isComponentName = "createAn4";
        this.component++;
        this.mergeArr = this.$refs.createAn.mergeArr;
        this.pladList = this.$refs.createAn.pladList;
        this.calcParam = this.$refs.createAn.calcParam;

        return;
      }

      if (this.isComponentName === "createAn4") {
        this.calcData = this.$refs.createAn.calcData;
        this.createAn4Param = this.$refs.createAn.createAn4Param;

        console.log(this.createAn4Param);
        let createAn4 = this.$refs.createAn;

        if (createAn4.payment === null) {
          this.$message("请选择支付方式");
          return;
        }

        if (createAn4.payment === 0) {
          this.isComponentName = "shouxin1";
          return;
        }
        if (createAn4.payment === 1) {
          this.isComponentName = "zhifubao1";
          request({
            url: "/api/app/create",
            method: "POST",
            data: this.calcData,
          }).then((res) => {
            this.openURL = `/api/redirect/order/${res.data.oid}`;
            setTimeout(() => {
              this.ZHIFUBAO = res.data.oid;
            }, 3000);
          });
          return;
        }
        if (createAn4.payment === 2) {
          this.isComponentName = "createAn5";
          return;
        }
      }

      if (this.isComponentName === "createAn5") {
        // 余额支付
        if (this.$refs.createAn.password == "") {
          this.$message.error("请输入密码");
          return;
        }
        this.payLoading = true;
        this.calcData.passcode = this.$refs.createAn.password;

        if (this.calcData.pay_way === "0") {
          request({
            url: "/api/app/create",
            method: "POST",
            data: this.calcData,
          })
            .then((res) => {
              if (res.code === 0) {
                this.isSucceed = true; // 控制支付成功或者失败状态
                this.appData = res;
                this.isComponentName = "createAn6";
              } else {
                this.appData = null;
                this.isSucceed = false; // 控制支付成功或者失败状态
                this.isComponentName = "createAn6";
              }
              this.payLoading = false;
            })
            .catch((err) => {
              this.payLoading = false;
            });
        } else {
          request({
            url: "/api/app/create",
            method: "POST",
            data: this.calcData,
          })
            .then((res) => {
              this.isComponentName = "createAn6";
              this.appData = res;
              if (res.code === 0) {
                this.isSucceed = true; // 控制支付成功或者失败状态
              } else {
                this.isSucceed = false; // 控制支付成功或者失败状态
              }
              this.payLoading = false;
            })
            .catch((err) => {
              this.payLoading = false;
            });
        }

        return;
      }

      if (this.isComponentName === "shouxin1") {
        // 信用模式
        this.calcData = this.$refs.createAn.calcData2;

        if (this.calcData.pay_way === 1) {
          this.isComponentName = "zhifubao1";
          request({
            url: "/api/app/create",
            method: "POST",
            data: this.calcData,
          }).then((res) => {
            this.openURL = `/api/redirect/order/${res.data.oid}`;
            setTimeout(() => {
              this.ZHIFUBAO = res.data.oid;
            }, 3000);
          });

          // 支付宝支付
          return;
        }

        if (this.calcData.pay_way === 0) {
          this.isComponentName = "createAn5";
        }

        return;
      }
    },

    getPlatformName: function (arr) {
      let textArr = [];
      for (let item of arr) {
        if (item.status === true) {
          textArr.push(item.title);
        }
      }
      return Promise.resolve(textArr.join("、"));
    },

    nextStep2: function () {
      // 余额
      // 前往支付页面或者下一步
      if (this.isSucceed) {
        // 下一步
        this.isComponentName = "createAn7";
        this.isButtom3 = true;
      } else {
        console.log(this.calcData);
        //

        if (this.calcData.pay_way === 0) {
          this.$router.push("/Dashboard/point-of-sale");
          // 前往支付页面
        }

        if (this.calcData.pay_way === 1) {
          const loading = this.$loading({
            lock: true,
            text: "查询中····",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          //  支付宝
          request({
            url: `/api/order/check/${this.ZHIFUBAO}`,
          }).then((res) => {
            this.appData = res;
            loading.close();
            if (res.data.state === "0") {
              this.$message.error("未支付");
              return;
            }

            if (res.data.state === "2") {
              this.$message.error("支付失败");
              return;
            }

            if (res.data.state === "1") {
              this.$message({
                message: "恭喜你，这是一条成功消息",
                type: "success",
              });
              this.isSucceed = true;
              return;
            }
          });
        }

        if (this.calcData.pay_way === "2") {
          //  微信
        }
      }
    },

    nextStep3: function (value) {
      if (value === "稍后设置") {
        this.isComponentName = "createAn8";
        this.isButtom3 = false;
        this.isButtom4 = true;
        this.component = 5;
      } else {
        let createAn7 = this.$refs.createAn.createAn7;
        let param = {
          uuid: this.appData.data.uuid,
          platform: {},
        };

        for (let i in createAn7) {
          // 校验内容是否符合规则
          if (!createAn7[i].name) {
            this.$message.error(`${this.fSystem(createAn7[i].title)} 端APP名称不能为空`);
            return;
          } else {
            param.platform[createAn7[i].title] = {
              name: createAn7[i].name,
              icon: "",
            };
          }
        }
        param.platform.main = {
          name: this.$refs.createAn.hostName,
          icon: "",
        };
        // 下一步
        request({
          url: "/api/app/edit",
          method: "POST",
          data: param,
        }).then((res) => {
          this.isComponentName = "createAn8";
          this.isButtom3 = false;
          this.isButtom4 = true;
          this.component = 5;
        });
      }
      setTimeout(() => {
        this.loading8 = false;
      }, 2000);
    },
    //  前往我的应用页面
    nextStep4: function () {
      if (this.userInfo.id_card === "") {
        this.isIdCard = true;
        console.log("前往认证");
      } else {
        this.$router.push("/Dashboard/myApp");
      }
      this.isButtom4 = false;
    },
    // left
    lastStep: function () {
      if (this.isComponentName === "createAn1") {
        this.$router.go(-1);
        this.component--;
        return;
      }
      if (this.isComponentName === "createAn2") {
        this.isComponentName = "createAn1";
        this.component--;
        return;
      }

      if (this.isComponentName === "createAn4") {
        this.isComponentName = "createAn2";
        this.component--;

        return;
      }

      if (this.isComponentName === "createAn5") {
        this.isComponentName = "createAn4";
        return;
      }

      if (this.isComponentName === "createAn6") {
        this.isComponentName = "createAn4";
        return;
      }
      if (this.isComponentName === "shouxin1") {
        this.isComponentName = "createAn4";
        return;
      }
    },
    lastStep2: function () {
      this.isComponentName = "createAn4";
      this.isSucceed = true;
    },

    getPlan: function () {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      request({
        url: "/api/app/plan",
      }).then((res) => {
        res.data.forEach((element, index) => {
          element.laber = false;
          if (index === 0) {
            element.spanActive = true;
          } else {
            element.spanActive = false;
          }
          element.laber = false;
          loading.close();
        });
        this.planData = res.data;
      });
    },

    // 支付宝 ---  我已经支付完成， 查询支付结果
    getPayResults: function () {
      request({
        url: `/api/order/check/${this.ZHIFUBAO}`,
      }).then((res) => {
        this.appData = res;
        if (res.data.state === "0") {
          this.isComponentName = "createAn6";
          this.isSucceed = false;
          return;
        }

        if (res.data.state === "2") {
          this.isComponentName = "createAn6";
          this.isSucceed = false;
          return;
        }

        if (res.data.state === "1") {
          this.isComponentName = "createAn6";
          this.isSucceed = true;
          return;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.createTitle {
  margin: 41px 0 15px;
  color: #2d3748;
  font-size: 18px;
  display: block;
}

.createHtml-box {
  overflow: hidden;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
}

.createHtml {
  border-bottom: 1px solid #f5f5f5;
}

.createBody {
  width: 100%;
  background: #ffffff;
  border-radius: 22px;
}

.steps-box {
  padding: 40px 100px;
}

.createrAn-Buttom-box {
  widows: 100%;
  display: flex;
  width: 77.6%;
  padding: 40px 0 80px;
  margin: 0 auto;
  justify-content: space-between;
}

.createrAn-Buttom {
  .span0 {
    display: inline-block;
    width: 96px;
    height: 37px;
    line-height: 37px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;
  }
  .span9 {
    display: inline-block;
    width: 208px;
    height: 37px;
    line-height: 37px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;
  }

  .span1 {
    color: #788598;
    background: #edf1f6;
  }
  .span1:active {
    background: #f8f8f8;
  }

  .span2 {
    color: rgb(235, 233, 233);
    background: #1890ff;
    margin-left: 20px;
  }
  .span2:active {
    background: #2d97fa;
  }
}

.loading8Clss {
  background: #e2f0ff !important;
  cursor: no-drop !important;
  color: #ffffff !important;
}

.button {
  width: 236px;
  height: 37px;
  background: #1890ff;
  border-radius: 12px;
  text-align: center;
  display: inline-block;
  font-size: 14px;
  color: #fff;
}

.button:active {
  background: #399fff;
}

@media screen and (max-width: 600px) {
  .createHtml {
    display: none !important;
  }

  .createrAn-Buttom {
    display: flex !important;
    padding: 20px !important;
    justify-content: center;
    align-items: center;
    .span2 {
      margin-left: 20px !important;
    }
  }
}
</style>
